import UserOutlined from '@ant-design/icons/UserOutlined';
import SafetyCertificateOutlined from '@ant-design/icons/SafetyCertificateOutlined';
import HistoryOutlined from '@ant-design/icons/HistoryOutlined';
import ArrowLeftOutlined from '@ant-design/icons/ArrowLeftOutlined';
import KeyOutlined from '@ant-design/icons/KeyOutlined';
import SettingOutlined from '@ant-design/icons/SettingOutlined';

// ==============================|| MENU ITEMS - AUTH MODULE ||============================== //

const auth = {
  id: 'group-auth',
  title: 'Acessos',
  type: 'group',
  children: [
    {
      id: 'back-to-core',
      title: 'Voltar ao Principal',
      type: 'item',
      url: '/dashboard',
      icon: ArrowLeftOutlined,
      breadcrumbs: false
    },
    {
      id: 'usuarios',
      title: 'Usuários',
      type: 'item',
      url: '/auth/usuarios',
      icon: UserOutlined,
      permissions: ['auth.users.view'],
      breadcrumbs: false
    },
    {
      id: 'perfis',
      title: 'Perfis (Roles)',
      type: 'item',
      url: '/auth/perfis',
      icon: SafetyCertificateOutlined,
      permissions: ['auth.roles.view'],
      breadcrumbs: false
    },
    {
      id: 'auth-configuracoes',
      title: 'Configurações',
      type: 'collapse',
      icon: SettingOutlined,
      children: [
        {
          id: 'permissoes',
          title: 'Permissões',
          type: 'item',
          url: '/auth/permissoes',
          icon: KeyOutlined,
          permissions: ['auth.permissions.view'],
          breadcrumbs: false
        },
        {
          id: 'auditoria',
          title: 'Logs de Auditoria',
          type: 'item',
          url: '/auth/auditoria',
          icon: HistoryOutlined,
          permissions: ['auth.audit.view'],
          breadcrumbs: false
        }
      ]
    }
  ]
};

export default auth;
